export default __webpack_public_path__ + "1f409de9df54e5775cce23034c977caf.svg";